import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
const baseUrl = environment['baseUrl'];
@Injectable({
  providedIn: 'root',
})
export class ApicallService {
  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}
  entityAccess(body: any): Observable<any> {
    return this.http.post(`${baseUrl}entity_id_access`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  getTotalcount(
    sdate: any,
    edate: any,
    area: any,
    forklift: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}incident_count?start_date=${sdate}&end_date=${edate}&area=${area}&forklift=${forklift}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  // Method to get ppe zone analytics
  getVehicleAnalytics(sdate: any, edate: any, device_id: any): Observable<any> {
    return this.http
      .get(
        `${baseUrl}vechicle_analytics?start_date=${sdate}&end_date=${edate}&device_id=${device_id}&limit=30000&offset=0`,
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getVehicleincAnalytics(
    sdate: any,
    edate: any,
    device_id: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}vechicle_inc_count?start_date=${sdate}&end_date=${edate}&device_id=${device_id}&limit=30000&offset=0`,
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  // download area/gate report
  downloadGateReport(sdate: any, edate: any, entity_id: any): Observable<Blob> {
    return this.http
      .get(
        `${baseUrl}download_report?start_date=${sdate}&end_date=${edate}&entity_id=${entity_id}`,
        {
          responseType: 'blob', // Expect a file response
        },
      )
      .pipe(
        catchError((err: any) => {
          console.error('Download failed:', err);
          throw err;
        }),
      );
  }
  downloadCityReport(sdate: any, edate: any): Observable<Blob> {
    return this.http
      .get(`${baseUrl}city_wise_report?start_date=${sdate}&end_date=${edate}`, {
        responseType: 'blob', // Expect a file response
      })
      .pipe(
        catchError((err: any) => {
          console.error('Download failed:', err);
          throw err;
        }),
      );
  }
  // download forklift report
  downloadForkliftReport(
    sdate: any,
    edate: any,
    forklift: any,
  ): Observable<Blob> {
    return this.http
      .get(
        `${baseUrl}download_report?start_date=${sdate}&end_date=${edate}&forklift=${forklift}`,
        {
          responseType: 'blob', // Expect a file response
        },
      )
      .pipe(
        catchError((err: any) => {
          console.error('Download failed:', err);
          throw err;
        }),
      );
  }
  getAnalytics(sdate: any, edate: any): Observable<any> {
    return this.http
      .get(`${baseUrl}ppe_analytics?start_date=${sdate}&end_date=${edate}`)
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  // get area/gate graph data
  getGateAnalytics(
    sdate: any,
    edate: any,
    // worksite: any,
    // zone: any,
    // geofence_id:any,
    // entity_id: any,
    // vehicle: any,
    trend: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}incidents/analytics_daywise?start_date=${sdate}&end_date=${edate}&location_id=${trend}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getPlantAnalytics(
    sdate: any,
    edate: any,
    // worksite: any,
    zone: any,
    vehicle: any,
    trend: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}plant_day_wise_analytics?start_date=${sdate}&end_date=${edate}&zone_id=${zone}&vehicle=${vehicle}&trend=${trend}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getHardHatPlantAnalytics(
    sdate: any,
    edate: any,
    // worksite: any,
    zone: any,
    vehicle: any,
    typeParam: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}helmet_analytics?start_date=${sdate}&end_date=${edate}&zone_id=${zone}&vehicle=${vehicle}&monthwise=${typeParam}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getGateAnalyticsFilter() {
    return this.http
      .get(`${baseUrl}location/dropdown_filter`, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getGateAnalyticsHour(
    sdate: any,
    edate: any,
    // worksite: any,
    // zone: any,
    // geofence_id:any,
    // vehicle: any,
    // entity_id: any,
    trend: any,
    type?: string,
  ): Observable<any> {
    let url = `${baseUrl}incidents/analytics_hourwise?start_date=${sdate}&end_date=${edate}&location_id=${trend}`;

    return this.http.get(url, { withCredentials: true }).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.error(err);
        throw err;
      }),
    );
  }
  getGateAnalyticsMonth(
    sdate: any,
    edate: any,
    // worksite: any,
    // zone: any,
    // geofence_id:any,
    // vehicle: any,
    // entity_id: any,
    trend: any,
    type?: string,
  ): Observable<any> {
    let url = `${baseUrl}incidents/analytics_monthwise?start_date=${sdate}&end_date=${edate}&location_id=${trend}`;

    return this.http.get(url, { withCredentials: true }).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.error(err);
        throw err;
      }),
    );
  }
  getPlantAnalyticsMonth(
    sdate: any,
    edate: any,
    // worksite: any,
    zone: any,
    vehicle: any,
    trend: any,
    type?: string,
  ): Observable<any> {
    let url = `${baseUrl}plant_month_wise_analytics?start_date=${sdate}&end_date=${edate}&zone_id=${zone}&vehicle=${vehicle}&trend=${trend}`;

    return this.http.get(url, { withCredentials: true }).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.error(err);
        throw err;
      }),
    );
  }
  getMHEAnalytics(sdate: any, edate: any): Observable<any> {
    return this.http
      .get(`${baseUrl}mhe_analytics?start_date=${sdate}&end_date=${edate}`, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  // get data to plot the donut chart
  getDonut(
    sdate: any,
    edate: any,
    // worksite: any,
    // entity_id: any
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}incidents/analytics_cards?start_date=${sdate}&end_date=${edate}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }

  getPlantDonut(
    sdate: any,
    edate: any,
    // worksite: any,
    zone: any,
    vehicle: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}plant_report?start_date=${sdate}&end_date=${edate}&zone_id=${zone}&vehicle=${vehicle}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getHelmetCountDonut(
    sdate: any,
    edate: any,
    // worksite: any,
    zone: any,
    vehicle: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}helmet_count?start_date=${sdate}&end_date=${edate}&zone_id=${zone}&vehicle=${vehicle}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getvehicleVSincidents(
    sdate: any,
    edate: any,
    value: any,
    vehicle: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}analytical/group_analytics?start_date=${sdate}&end_date=${edate}&vehicle=${vehicle}&analytics=${value}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  // donut_graph_ppe
  getDonutPpe(sdate: any, edate: any): Observable<any> {
    return this.http
      .get(`${baseUrl}donut_graph_ppe?start_date=${sdate}&end_date=${edate}`)
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getSearchbyId(id: any): Observable<any> {
    return this.http
      .get(`${baseUrl}incidents/search_by_id?id=${id}`, { withCredentials: true })
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }

  getSafteyIncidentsP(
    sdate: any,
    edate: any,
    entity_id: any,
    location: any,
    // departments: any,
    // sub_departments: any,
    camera: any,
    falseReport: any,
    detection: any,
    offset: any,
    limit: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}incidents/card_details?start_date=${sdate}&end_date=${edate}&location_id=${location}&cameras=${camera}&false_report=${falseReport}&class_ids=${detection}&offset=${offset}&limit=${limit}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getSafteyIncidentsPTotal(
    sdate: any,
    edate: any,
    entity_id: any,
    location: any,
    // departments: any,
    // sub_departments: any,
    camera: any,
    falseReport: any,
    detection: any,
    id: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}incidents/pagination_count?start_date=${sdate}&end_date=${edate}&location_id=${location}&cameras=${camera}&class_ids=${detection}&false_report=${falseReport}&id=${id}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getSafteyIncidentsPPETotal(
    sdate: any,
    edate: any,
    // site_id: any,
    zone: any,
    geofence_id: any,
    d_id: any,
    camera: any,
    detection: any,
    false_report: any,
    status: any,
    inc_type: any,
    id: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}incidents/pagination_count?start_date=${sdate}&end_date=${edate}&zone=${zone}&geofence=${geofence_id}&vehicle=${d_id}&cam=${camera}
        &ticket_status=${status}&detection_type=${detection}&false_report=${false_report}&incident_type=${inc_type}&id=${id}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getSafteyIncidents(
    sdate: any,
    edate: any,
    // dg_id: any,
    dv_id: any,
    dv_name: any,
    inc_type: any,
    status: any,
    // gcamera: any,
    vcamera: any,
    detection: any,
    falseReport: any,
    offset: any,
    limit: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}safety_details?start_date=${sdate}&end_date=${edate}&device_id=${dv_id}&vehicle_name=${dv_name}&inc_type=${inc_type}&ticket_status=${status}&vehicle_camera_pos=${vcamera}&detection_type=${detection}&false_report=${falseReport}&offset=${offset}&limit=${limit}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getSafteyIncidentsTotal(
    sdate: any,
    edate: any,
    // dg_id: any,
    dv_id: any,
    dv_name: any,
    inc_type: any,
    status: any,
    // gcamera: any,
    vcamera: any,
    detection: any,
    falseReport: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}safety_details_count?start_date=${sdate}&end_date=${edate}&device_id=${dv_id}&vehicle_name=${dv_name}&inc_type=${inc_type}&ticket_status=${status}&vehicle_camera_pos=${vcamera}&detection_type=${detection}&false_report=${falseReport}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getPlantIncidentsPPETotal(
    sdate: any,
    edate: any,
    // site_id: any,
    zone: any,
    d_id: any,
    camera: any,
    detection: any,
    falseReport: any,
    status: any,
    inc_type: any,
    id: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}plant_ppe_pagination?start_date=${sdate}&end_date=${edate}&zone=${zone}&device_id=${d_id}&cam=${camera}
        &ticket_status=${status}&detection_type=${detection}&false_report=${falseReport}&incident_type=${inc_type}&id=${id}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getGatePPESafteyIncidents(
    sdate: any,
    edate: any,
    // site_id: any,
    zone: any,
    geofence_id: any,
    d_id: any,
    camera: any,
    detection: any,
    falseReport: any,
    status: any,
    inc_type: any,
    offset: any,
    limit: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}safety/list?start_date=${sdate}&end_date=${edate}&zone=${zone}&geofence=${geofence_id}&vehicle=${d_id}&cam=${camera}
        &detection_type=${detection}&false_report=${falseReport}&ticket_status=${status}&incident_type=${inc_type}&offset=${offset}&limit=${limit}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }

  getPlantPPEIncidents(
    sdate: any,
    edate: any,
    // site_id: any,
    zone: any,
    d_id: any,
    camera: any,
    detection: any,
    falseReport: any,
    status: any,
    inc_type: any,
    offset: any,
    limit: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}plant_ppe_compliance?start_date=${sdate}&end_date=${edate}&zone=${zone}&device_id=${d_id}&cam=${camera}
        &detection_type=${detection}&false_report=${falseReport}&ticket_status=${status}&incident_type=${inc_type}&offset=${offset}&limit=${limit}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }

  getGatePPESafteyIncidentsTotal(
    sdate: any,
    edate: any,
    // site_id: any,
    zone: any,
    d_id: any,
    camera: any,
    direction: any,
    detection: any,
    inc_type: any,
    // status: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}incidents/pagination_count?start_date=${sdate}&end_date=${edate}&zone=${zone}&vehicle=${d_id}&cam=${camera}
        &direction=${direction}&detection_type=${detection}&incident_type=${inc_type}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getSafteyIncidentsD(
    sdate: any,
    edate: any,
    d_id: any,
    d_name: any,
    inc_type: any,
    status: any,
    camera: any,
    detection: any,
    offset: any,
    limit: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}safety_details?start_date=${sdate}&end_date=${edate}&device_id=${d_id}&vehicle_name=${d_name}&inc_type=${inc_type}&ticket_status=${status}&camera_pos=${camera}&detection_type=${detection}&offset=${offset}&limit=${limit}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getSafteyIncidentsDTotal(
    sdate: any,
    edate: any,
    d_id: any,
    d_name: any,
    inc_type: any,
    status: any,
    camera: any,
    detection: any,
  ): Observable<any> {
    return this.http
      .get(
        `${baseUrl}safety_details_count?start_date=${sdate}&end_date=${edate}&device_id=${d_id}&vehicle_name=${d_name}&inc_type=${inc_type}&ticket_status=${status}&camera_pos=${camera}&detection_type=${detection}`,
        { withCredentials: true },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  // get image of safety details
  getSafetyImage(e_id: any, d_id: any, time: any) {
    return this.http
      .get(
        `${baseUrl}inc_image?entity_id=${e_id}&device_id=${d_id}&inc_time=${time}`,
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  getSafeDays(sdate: any, edate: any) {
    return this.http
      .get(`${baseUrl}safe_man_days?start_date=${sdate}&end_date=${edate}`)
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }

  getIncidentAdd(sdate: any, edate: any) {
    return this.http
      .get(`${baseUrl}incident_addressed?start_date=${sdate}&end_date=${edate}`)
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }

  getNonComplianceIncident(sdate: any, edate: any): Observable<any> {
    return this.http
      .get(`${baseUrl}non_compilance?start_date=${sdate}&end_date=${edate}`)
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  // update ticket status
  ticketStatus(body: any): Observable<any> {
    return this.http.put(`${baseUrl}ticket_status`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  // update ticket description
  ticketDescription(body: any): Observable<any> {
    return this.http.post(`${baseUrl}incidents/feedback_post`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  // ignore flag
  ignoreStatus(body: any): Observable<any> {
    return this.http.put(`${baseUrl}incidents/false_report`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  // get ticket description
  getticketDescription(inc_id: any): Observable<any> {
    return this.http
      .get(`${baseUrl}incidents/feedback_read?id=${inc_id}`)
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }

  probabilityRating(body: any): Observable<any> {
    return this.http.post(`${baseUrl}rating`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }

  getProbabilityRating(inc_id: any): Observable<any> {
    return this.http.get(`${baseUrl}rating?incident_id=${inc_id}`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }

  getResponseTime(): Observable<any> {
    return this.http.get(`${baseUrl}avg_response_time`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  // get user list
  getUserTable(): Observable<any> {
    return this.http.get(`${baseUrl}accounts/users`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  // get plant list
  getPlantTable(): Observable<any> {
    return this.http.get(`${baseUrl}plant`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  profileUpload(file: any): Observable<any> {
    return this.http.post(`${baseUrl}profile_upload`, file).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  // add new user
  AddUser(body: any): Observable<any> {
    return this.http.post(`${baseUrl}accounts/user/create`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  getRoleList(): Observable<any> {
    return this.http.get(`${baseUrl}accounts/roles`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  // edit existing user details
  EditUser(body: any): Observable<any> {
    return this.http.put(`${baseUrl}accounts/user/update`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  // delete user details
  DeleteUser(id: any): Observable<any> {
    return this.http.delete(`${baseUrl}accounts/user/delete?id=${id}`).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }

  getSiteTabel(): Observable<any> {
    return this.http.get(`${baseUrl}site`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  AddSite(body: any): Observable<any> {
    return this.http.post(`${baseUrl}site`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  EditSite(body: any): Observable<any> {
    return this.http.put(`${baseUrl}site`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  DeleteSite(id: any): Observable<any> {
    return this.http.delete(`${baseUrl}site?id=${id}`).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  getZoneTable(): Observable<any> {
    return this.http.get(`${baseUrl}zone`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  AddZone(body: any): Observable<any> {
    return this.http.post(`${baseUrl}zone`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  EditZone(body: any): Observable<any> {
    return this.http.put(`${baseUrl}zone`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  DeleteZone(id: any): Observable<any> {
    return this.http.delete(`${baseUrl}zone?id=${id}`).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  getGeofenceTable(id: any): Observable<any> {
    return this.http.get(`${baseUrl}geofence?zone_id=${id}`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  AddGeofence(body: any): Observable<any> {
    return this.http.post(`${baseUrl}geofence`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  EditGeofence(body: any): Observable<any> {
    return this.http.put(`${baseUrl}geofence`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  DeleteGeofence(id: any): Observable<any> {
    return this.http.delete(`${baseUrl}geofence?id=${id}`).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  getVehicleTable(): Observable<any> {
    return this.http.get(`${baseUrl}warehouse`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  // EditVehicle(body: any): Observable<any> {
  //   return this.http.put(`${baseUrl}manage_vehicle`, body).pipe(
  //     map((response: any) => {
  //       return response;
  //     },
  //       (err: any) => {
  //         console.log(err);
  //       }
  //     )
  //   );
  // }
  DeleteVehicle(id: any): Observable<any> {
    return this.http.delete(`${baseUrl}warehouse?id=${id}`).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  getDriverTable(): Observable<any> {
    return this.http.get(`${baseUrl}drivers`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  AddDevice(body: any): Observable<any> {
    return this.http.post(`${baseUrl}manage_device`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  EditDevice(body: any): Observable<any> {
    return this.http.put(`${baseUrl}manage_device`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  DeleteDevice(id: any): Observable<any> {
    return this.http.delete(`${baseUrl}manage_device?id=${id}`).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }

  getOperatorTable(): Observable<any> {
    return this.http.get(`${baseUrl}manage_driver`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  AddOperator(body: any): Observable<any> {
    return this.http.post(`${baseUrl}drivers`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  EditOperator(body: any): Observable<any> {
    return this.http.put(`${baseUrl}drivers`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  DeleteOperator(id: any): Observable<any> {
    return this.http.delete(`${baseUrl}drivers?id=${id}`).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  getDevicesUnused() {
    return this.http.get(`${baseUrl}unuse_device`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }

  // getFilters() {

  //   return this.http
  //     .get(`${baseUrl}filter_search`, { withCredentials: true }) // withCredentials ensures cookies are sent
  //     .pipe(
  //       map((response: any) => response),
  //       catchError((err: any) => {
  //         console.log(err);
  //         throw err;
  //       })
  //     );
  // }
  getFilters() {
    return this.http
      .get(`${baseUrl}location/filter`, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  // downlad incident image
  DownloadImgMedia(
    time: any,
    deviceid: any,
    classid: any,
    entity: any,
    type: any,
  ) {
    return this.http
      .get(
        `${baseUrl}download_media?inc_time=${time}&device_id=${deviceid}&class_id=${classid}&entity_id=${entity}&type=${type}`,
        { responseType: 'blob' },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  // download incident video
  DownloadVidMedia(
    time: any,
    deviceid: any,
    classid: any,
    entity: any,
    type: any,
  ) {
    return this.http
      .get(
        `${baseUrl}download_media?inc_time=${time}&device_id=${deviceid}&class_id=${classid}&entity_id=${entity}&type=${type}`,
        { responseType: 'blob' },
      )
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.log(err);
          throw err;
        }),
      );
  }
  AddVehicle(body: any): Observable<any> {
    return this.http.post(`${baseUrl}warehouse`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  EditVehicle(body: any): Observable<any> {
    return this.http.put(`${baseUrl}warehouse`, body).pipe(
      map(
        (response: any) => {
          return response;
        },
        (err: any) => {
          console.log(err);
        },
      ),
    );
  }
  getDoropdownValues(): Observable<any> {
    return this.http.get(`${baseUrl}vehicles_dropdowns`).pipe(
      map((response: any) => response),
      catchError((err: any) => {
        console.log(err);
        throw err;
      }),
    );
  }
  getActuals(sDate: any, eDate: any, value: any): Observable<any> {
    // let v:any;
    // if(vehicle.length == 0){
    //   v = ""; //api call fails when no vehicle id is passed
    // }
    // else{
    //   v = `&vehicle=${vehicle}`
    // }
    // const sDate = new Date(new Date(filters['start_date']).setHours(0, 0, 0, 0)).getTime() ;
    // const eDate = (new Date(new Date(filters['end_date']).setHours(23, 59, 59, 999)).getTime()).toFixed(0);

    return this.http
      .get(
        `${baseUrl}analytical/group_analytics?start_date=${sDate}&end_date=${eDate}&vehicle=${value}&analytics=ccvsdu`,
      )
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            // console.log(error)
          },
        ),
      );
  }
  getPredict(sDate: any, eDate: any, value: any): Observable<any> {
    // const sDate = new Date(new Date(filters['start_date']).setHours(0, 0, 0, 0)).getTime() ;
    // const eDate = (new Date(new Date(filters['end_date']).setHours(23, 59, 59, 999)).getTime()).toFixed(0);
    // // console.log(sDate,eDate)
    return this.http
      .get(
        `${baseUrl}analytical/prediction?start_date=${sDate}&end_date=${eDate}&vehicle=${value}&prediction=dsr`,
      )
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            // console.log(error);
          },
        ),
      );
  }
  getLight(sDate: any, eDate: any, value: any): Observable<any> {
    // const sDate = new Date(new Date(filters['start_date']).setHours(0, 0, 0, 0)).getTime() ;
    // const eDate = (new Date(new Date(filters['end_date']).setHours(23, 59, 59, 999)).getTime()).toFixed(0);
    // // console.log(sDate,eDate)
    return this.http
      .get(
        `${baseUrl}analytical/group_analytics?start_date=${sDate}&end_date=${eDate}&vehicle=${value}&analytics=ccvsli`,
      )
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            // console.log(error)
          },
        ),
      );
  }
  getRisk(yVal: any, ppval: any): Observable<any> {
    return this.http
      .get(
        `${baseUrl}analytical/analytics?year=${yVal}&vehicle=${ppval}&analytics=ppe`,
      )
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            // console.log(error)
          },
        ),
      );
  }
  getWhh(sDate: any, eDate: any, value: any): Observable<any> {
    // const sDate = new Date(new Date(filters['start_date']).setHours(0, 0, 0, 0)).getTime() ;
    // const eDate = (new Date(new Date(filters['end_date']).setHours(23, 59, 59, 999)).getTime()).toFixed(0);

    return this.http
      .get(
        `${baseUrl}analytical/analytics?start_date=${sDate}&end_date=${eDate}&vehicle=${value}&analytics=helmet`,
      )
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            // console.log(error)
          },
        ),
      );
  }
  getHuman(Y: any, M: any, V: any, P: any): Observable<any> {
    return this.http
      .get(
        `${baseUrl}analytical/analytics?people=${P}&year=${Y}&month=${M}&vehicle=${V}&analytics=human`,
      )
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            // console.log(error)
          },
        ),
      );
  }
  // get config management details
  getConfigManagement(roleId: number): Observable<any[]> {
    const url = `${baseUrl}config_management`;
    const params = new HttpParams().set('role_id', roleId.toString()); // Send role_id instead of role name
    return this.http.get<any[]>(url, { params });
  }
  // update config management changes
  saveConfigManagement(payload: any[]): Observable<any> {
    console.log(payload);
    return this.http.put(`${baseUrl}config_management`, payload);
  }
  getLocationDetails(): Observable<any> {
    return this.http
      .get(`${baseUrl}location/map`, { withCredentials: true })
      .pipe(
        map((response: any) => response),
        catchError((err: any) => {
          console.error('Error fetching location details:', err);
          throw err;
        }),
      );
  }
  forwardMail(email: any, incident_id: any, pagetype: any): Observable<any> {
    return this.http
      .get(
        `${baseUrl}incidents/mail_forwarding?email=${email}&incident_id=${incident_id}&page_type=${pagetype}`,
      )
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (err: any) => {
            return err;
            console.log(err);
          },
        ),
      );
  }
}
